<template>
  <v-container>
    <div v-show="isVisibleProp"></div>
      <v-row>
        <v-col cols="3">
          <v-text-field id="miscEditDialogFyText"
            class="misc-edit-dialog-fy-text"
            label="Fiscal Year"
            v-model.number="editedItem.fiscalYear"
            type="number"
            @change="loadLists"
            :rules="fiscalYearValidation"
            @blur="determineReceiptNo(), determineTransactionNo()"
            :disabled="true"
          ></v-text-field>
        </v-col>
        <v-col cols="3">
          <ClarionDateControl id="miscEditDialogBuisnessDate"
          class="misc-edit-dialog-buisness-date"
          :isIsoDate="true"
          label="Business Date"
          v-model="editedItem.businessDate"
          :isToggle="false"
          :rules="[businessDateValidation, ...registerDateRules]"
          />
        </v-col>
        <v-col cols="3">
          <GetMaxReceiptNumber id="miscEditDialogReceiptNumber"
            class="misc-edit-dialog-receipt-number"
            v-model.number="editedItem.receiptNumber"
            :fiscalYear="editedItem.fiscalYear"
            :isNewItem="isNewItem"
            :rules="reqdSelectValidation"
            fieldType="Receipt Number"
          />
        </v-col>
        <v-col cols="3">
          <v-text-field id="miscEditDialogWorkStationSelect"
            v-model="editedItem.wkst"
            class="misc-editDialog-work-station-select"
            label="Work Station"
            type="string"
            :disabled="!disableEditWkst"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="3">
          <v-text-field id="miscEditDialogReceiptAmount"
            class="misc-edit-dialog-receipt-amount"
            label="Receipt Amount"
            v-model="editedItem.amount"
            @blur="roundAmount"
            @focus="amountToNum(), $event.target.select()"
            autofocus
          ></v-text-field>
        </v-col>
        <v-col cols="3">
          <v-autocomplete id="miscEditDialogReceivedOf"
            class="misc-trans-fund"
            label="Received Of"
            v-model="editedItem.whomStr"
            :items="whoms"
            @keydown="whomShortcutHandler"
            @update:list-index="whomUpdateSearchInputByNumber"
            @update:search-input="whomUpdateSearchInput"
            @focus="onFocusAutocomplete"
          ></v-autocomplete>
        </v-col>
        <v-col cols="3">
          <v-autocomplete id="miscEditDialogBankNameSelect"
            class="misc-editDialog-bank-name-select"
            label="Bank Alt Key"
            :items="banks"
            item-text="bankAltKey"
            item-value="_id"
            v-model="editedItem.bank"
            :rules="isBankAltkeyRequired"
            @keydown.tab.prevent="handleTab('isDescriptionRef')"
          ></v-autocomplete>
        </v-col>
        <v-col cols="3" v-if="editedItem.isApportionLikeTax">
          <v-text-field id="miscEditDialogTaxYearSelect"
            class="misc-editDialog-tax-year-select"
            label="Tax Year"
            :rules="reqdSelectValidation"
            v-model.number="editedItem.taxYear"
            type="number"
            :disabled="true"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="4">
          <v-textarea id="miscEditDialogDescriptionText"
            class="misc-edit-dialog-description-text"
            label="Description"
            rows="2"
            v-textAreaUppercase=globalSettingItem.conEverythingToCaps
            v-model="editedItem.description"
            ref=isDescriptionRef
          ></v-textarea>
        </v-col>
        <v-col cols="2">
          <v-checkbox id="miscEditDialogVoidCheckBox"
            class="misc-edit-dialog-void-checkbox"
            v-model="editedItem.isVoid"
            label="Void"
            @change="isVoidChecked"
          ></v-checkbox>
        </v-col>
        <v-col cols="2">
          <v-tooltip bottom max-width="320">
            <template v-slot:activator="{ on, attrs }">
              <!-- The hover listeners go on a plain wrapper, not on the v-checkbox:
                   a real DOM node gets native mouseenter/leave, and the wrapper spans
                   the label text too, which is what users actually aim at. -->
              <div class="d-inline-block" v-bind="attrs" v-on="on">
                <v-checkbox
                  id="miscEditDialogCorrectionCheckBox"
                  class="misc-edit-dialog-correction-checkbox"
                  v-model="editedItem.isCorrection"
                  label="Correction"
                  @change="isCorrectionChecked"
                ></v-checkbox>
              </div>
            </template>
            <span>{{ correctionHoverCaption }}</span>
          </v-tooltip>
        </v-col>
        <v-col cols="3">
        <v-checkbox id="miscEditDialogsApprCheckBox"
            class="misc-edit-dialog-spl-appr-checkbox"
            v-model="editedItem.isSpecialApportionment"
            @click="showSpecialApportionmentBtn"
            label="Special Apportionment"
          ></v-checkbox>
        </v-col>
        <v-col cols="3">
        <v-checkbox id="miscEditDialogsApprLikeTaxCheckBox"
            class="misc-edit-dialog-appr-like-tax-checkbox"
            v-model="editedItem.isApportionLikeTax"
            v-if = "editedItem.isApportionLikeTax || isNewItem"
            @click="showTaxSummaryReceiptBtn"
            label="Apportion Like Taxes"
          ></v-checkbox>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="3">
        <GetMaxTransNumber id="mtgTransItemTransNoText"
          v-model.number="editedItem.transactionNumber"
          class="mtg-trans-item-trans-no-Text"
          fieldType="Transaction Number"
          :rules="reqdSelectValidation"
          :fiscalYear="editedItem.fiscalYear"
          :cmnBaseCrudKey="baseCrudKey"
          :loadLastTransactionNo="loadLastTransactionNo"
        />
        </v-col>
          <v-col cols="3"></v-col>
        <v-col cols="3" v-if="editedItem.isSpecialApportionment">
          <ClarionDateControl id="miscEditDialogSpecialAxGlDate"
          class="misc-edit-dialog-special-ax-gl-date"
          :isIsoDate="true"
          label="GL Date"
          v-model="editedItem.specialAxGlDate"
          :isToggle="false"
          :rules="[specialAxGlDateValidation]"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <MiscDetails id="miscEditDialogMiscDetails"
            class="misc-edit-dialog-misc-details"
            v-if="forceReloadDetails"
            v-model="editedItem.details"
            :baseCrudKey="baseCrudKey"
            :amount="editedItem.amount"
            :transItem="editedItem"
            :funds="funds"
            :unitCodeNewMethodFalg="isUnitCodenewSetupUsed"
            :sources="sources"
            :unitCodes="unitCodes"
            :taxDistricts="taxDistricts"
            :taxUnits="taxUnits"
            @totalRemainingReconAmount="totalRemainingReconAmount"
            @setCalculatePercentage="setCalculatePercentage"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col v-if="!transactionId">
          <PaymentDetails id="miscEditDialogPaymentDetails"
            class="misc-edit-dialog-payment-details"
            v-model="editedItem.paymentDetails"
            toolbarTitle="Payment Details"
            :amount="editedItem.amount"
            :whomString="editedItem.whomStr"
            :cmnEnums="cmnEnums"
            :paymentTypeFlags="isPaymentDetailsRequiredDefaultPaymentType"
            :defaultPaymentType="miscSettingItem"
            :defaultForteConfig="defaultForteConfig"
            :isDialogBoxVisible="isDialogBoxVisible"
            :isTotal="true"
            :addDefaultRow="true"
            :isReadOnly="isCorrectionMode"
            :programType="'MISC'"
            :miscReceiptItem="editedItem"
            @forteResponse="miscForteResponse"
            @payrixSuccess="$emit('payrixSuccess')"
            @emitEditBatchPaymntItem="emitEditBatchPaymntItem"
            @totalRemainingPaymentAmount="totalRemainingPaymentAmount"
          />
        </v-col>
          <v-row
      v-if="transactionId"
    >
      <v-col>
        <PaymentDetails id="mtgTransItemPaymentDetails"
          class="mtg-trans-item-payment-details"
          toolbarTitle="Batch Payment Details"
          :isReadOnly="true"
          :value="transNumValue"
          :whomString="editedItem.receivedOf"
          :cmnEnums="cmnEnums"
          :isDialogBoxVisible="isVisibleProp"
          :paymentDetailsFlags="{ isCallForBatchPayment:true }"
          :isTotal="false"
          :transactionId="transactionId"
          :programType="'MTG'"
          @emitEditBatchPaymntItem="emitEditBatchPaymntItem"
        />
      </v-col>
    </v-row>
      </v-row>
    </v-container>
</template>

<script>
import {
  mapGetters,
  mapMutations,
  mapActions,
  mapState,
} from 'vuex';
import ClarionDateControl from '../../common/ClarionDateControl.vue';
import MiscDetails from './MiscDetails.vue';
import PaymentDetails from '../../common/paymentDetails/PaymentDetails.vue';
import GetMaxReceiptNumber from './GetMaxReceiptNumber.vue';
import {
  amountFormat,
  onFocusAutocomplete,
  amountToNumber,
  checkStringEmptiness,
} from '../../../util/shared/vue-global';
import {
  defaultDurationOfCorrection,
  isNotBeforeDate,
  toIsoDate,
  correctionHoverCaption,
  hasEnteredPaymentDetails,
  correctionClearsPaymentDetailsPrompt,
} from '../../../util/shared/tmc-global';
import MiscTransactionListMixin from './MiscTransactionList.mixin';
import GetMaxTransNumber from '../../common/transactionNumber/GetMaxTransNumber.vue';
import { isBudgetedFundOrCashFund } from '../../shared/shared.util';
import GlobalToCaps from '../../../util/shared/GlobalToCaps.mixin.vue';
// import { ConsoleApiName } from '@datadog/browser-logs';

const bankCrudKey = 'sharedBank';
const taxUnitCrudKey = 'miscTransTaxUnit';

export default {
  name: 'MiscTransactionEditedItem',
  /* 💣 🧨 💥 Why 'MiscTransactionListMixin' inside 'TransactionEditedItem.vue'? 💥 💣 🧨 */
  mixins: [MiscTransactionListMixin, GlobalToCaps],
  components: {
    ClarionDateControl,
    MiscDetails,
    GetMaxReceiptNumber,
    PaymentDetails,
    GetMaxTransNumber,
  },
  props: {
    baseCrudKey: {
      type: String,
      default: 'miscTrans-dialog',
    },
    attachmentConstants: {
      type: Object,
      default: () => {},
    },
  },
  data: () => ({
    correctionHoverCaption,
    whomLastSearched: undefined,
    totalReconAmount: null,
    totalRemainingPayAmt: null,
    funds: [],
    sources: [],
    unitCodes: [],
    taxUnits: [],
    forceReloadDetails: true,
    whomListCrudKey: 'miscWhom',
    taxDistrictCrudKey: 'sharedTaxDistrict',
    defaultForteConfig: {
      configScope: 'miscConfig',
      isRequiredForte: true,
    },
  }),
  watch: {
    editedItem: {
      handler(val) {
        this.$emit('editItem', val);
      },
      deep: true,
    },
    'editedItem.isSpecialApportionment': {
      handler(val) {
        if (val && !this.editedItem.specialAxGlDate) {
          this.editedItem.specialAxGlDate = this.editedItem.businessDate;
        }
      },
    },
    'editedItem.businessDate': {
      handler(val) {
        if (this.editedItem.isSpecialApportionment) {
          this.editedItem.specialAxGlDate = val;
        }
      },
    },

  },
  created() {
    this.determineReceiptNo();
    this.determineTransactionNo();
    this.loadLists();
    this.loadBanks({
      criteria: {
        notEmptyAltKey: true,
        limit: 0,
      },
      baseCrudKey: bankCrudKey,
    });
    this.loadConfig({ requiredScope: 'miscConfig' });
    this.prefillSpecialAxGlDate();
  },
  computed: {
    ...mapGetters('base/crud', [
      'item',
      'items',
      'index',
      'isVisible',
    ]),
    ...mapGetters([
      'todaysDate',
    ]),
    ...mapState({
      nextReceiptNumber: (state) => state.misc.miscTransaction.nextReceiptNumber,
      cmnEnums: (state) => ({
        cmnPaymentTypes: state.enums.MISCPaymentTypeEnum || [],
        cmnEFTTypes: state.enums.MISCEFTTypeEnum || [],
        cmnCardTypes: state.enums.MISCCardTypeEnum || [],
      }),
      miscSettingItem: (state) => state.SystemConfig.miscSettingItem || {},
      nextTransNumber: (state) => state.common.cmnTransNumber.nextTransNumber,
      transNoPulse: (state) => state.common.cmnTransNumber.transNoPulse,
      globalSettingItem: (state) => state.SystemConfig.globalSettingItem,
    }),
    isPaymentDetailsRequiredDefaultPaymentType() {
      return {
        eftPaymentType: this.isNewItem && this.miscSettingItem.eftPaymentType,
        ccPaymentType: this.isNewItem && this.miscSettingItem.ccPaymentType,
      };
    },
    isUnitCodenewSetupUsed() { // #migrateUnitCode -> remove this function after migration
      return this.miscSettingItem.useNewUnitCodeSetup;
    },
    isBankAltkeyRequired() {
      if (this.miscSettingItem && this.miscSettingItem.requireBankAltKey) {
        return [(value) => !!value || 'Required'];
      }
      return [];
    },
    disableEditWkst() {
      return this.miscSettingItem.editWkst;
    },
    editedItem: {
      get() {
        return this.item(this.baseCrudKey);
      },
      set(value) {
        this.setItem([this.baseCrudKey, value]);
      },
    },
    whoms() {
      const miscWhomsList = (this.items(this.whomListCrudKey) || []).map(
        (r) => r.description || '',
      );
      miscWhomsList.push(this.editedItem.whomStr || '');
      return miscWhomsList;
    },
    banks() {
      const bankObjs = this.items(bankCrudKey) || [];
      const updatedBankObjs = bankObjs.map((b) => ({
        ...b,
        bankAltKey: ` ${b.altKeyBase || ''} - ${b.bankName}`,
      }));
      return [{ _id: null, bankName: '', bankAltKey: '' }, ...updatedBankObjs];
    },
    taxDistricts() {
      const taxDistrictObjs = this.items(this.taxDistrictCrudKey) || [];
      const updatedTaxDistObj = taxDistrictObjs.map((t) => ({
        ...t,
        taxDistrictDesc: `${t.districtCode} ${t.districtName || ''}`,
      }));
      return [{ _id: null, districtCode: '', taxDistrictDesc: '' }, ...updatedTaxDistObj];
    },
    isNewItem() {
      return this.index(this.baseCrudKey) === -1;
    },
    isCorrectionMode() {
      return this.editedItem.isCorrection;
    },
    /* Todo - This is one of the bad way to handle dialog-box contents */
    isVisibleProp() {
      const isVisible = this.isVisible(this.baseCrudKey);
      if (isVisible) {
        this.loadLists();
        this.showTaxSummaryReceiptBtn();
        this.showSpecialApportionmentBtn();
        if (this.editedItem._id) {
          this.loadFiles();
        }
      } else {
        // do nothing
      }
      return isVisible;
    },
    /* Don't add any method call here, as here already some polling related work is going on */
    isDialogBoxVisible() {
      const isVisible = this.isVisible(this.baseCrudKey);
      if (isVisible) {
        if (this.isNewItem) {
          this.determineReceiptNo();
          this.determineTransactionNo();
        }
      } else {
        this.setReceiptPolling(undefined);
        this.setTransNoPolling(undefined);
      }
      return isVisible;
    },
    reqdSelectValidation() {
      return [
        (value) => !!value || 'Required',
      ];
    },
    durationOfCorrection() {
      if (this && this.miscSettingItem && this.miscSettingItem.durationOfCorrection) {
        return parseInt(this.miscSettingItem.durationOfCorrection, 10)
          || defaultDurationOfCorrection;
      }
      return defaultDurationOfCorrection;
    },
    registerDateRules() {
      return [
        (value) => {
          const isNotBefore = isNotBeforeDate(
            value, this.todaysDate, (this.durationOfCorrection + 1),
          );
          return isNotBefore || 'You are not allowed to change or enter transactions that'
            + ` are more than ${this.durationOfCorrection} business days old. Please use a correction`
            + ' transaction type for today\'s date instead.';
        },
        (value) => !!value || 'Required',
      ];
    },
    fiscalYearValidation() {
      return [
        (value) => !!value || 'Required',
        (value) => !Number.isNaN(parseFloat(value)) || 'Numeric required',
        (value) => parseFloat(value) > 0 || 'Must be a positive year',
        (value) => (value || '').toString().length === 4 || 'Fiscal year must be 4 digits',
        (value) => parseFloat(value) < 3000 || 'Must be a reasonable year',
      ];
    },
    fiscalYearLength() {
      return (this.editedItem.fiscalYear || '').toString().length;
    },
    transactionId() {
      return this.editedItem.transactionNumberObject
      && this.editedItem.transactionNumberObject._id;
    },
    transNumValue() {
      const copiedObj = JSON.parse(JSON.stringify((this.editedItem.transactionNumberObject || {})
        .paymentDetails || []));
      return copiedObj;
    },
  },
  methods: {
    handleTab() {
      if (this.$refs.isDescriptionRef) {
        this.$refs.isDescriptionRef.focus();
      }
    },
    ...mapMutations('base/crud', [
      'setItem',
    ]),
    ...mapActions('files', [
      'loadAttachedFiles',
    ]),
    ...mapActions('SystemConfig', [
      'loadConfig',
    ]),
    ...mapActions('common/cmnWhom', [
      'loadCmnWhom',
      'upsrtCmnWhom',
    ]),
    ...mapActions('shared/fund', [
      'loadFunds',
    ]),
    ...mapActions('shared/bank', [
      'loadBanks',
    ]),
    ...mapActions('shared/source', [
      'loadCmnSource',
    ]),
    ...mapActions('misc/schoolUnit', [
      'loadMiscUnitCode',
    ]),
    ...mapActions('shared/taxUnit', [
      'loadTaxUnit',
    ]),
    ...mapActions('misc/miscTransaction', [
      'loadLastReceiptNo',
      'loadLastTransactionNo',
    ]),
    ...mapActions([
      'flashError',
      'flashInfo',
    ]),
    ...mapMutations('misc/miscTransaction', [
      'setReceiptPolling',
      'setReceiptPulse',
    ]),
    ...mapMutations('common/cmnTransNumber', [
      'setTransNoPolling',
      'setTransNoPulse',
    ]),
    amountFormat,
    onFocusAutocomplete,
    amountToNumber,
    registerDateBlurred(value) {
      const isNotBeforeTwoPrior = isNotBeforeDate(
        value, this.todaysDate, (this.durationOfCorrection + 1),
      );
      const valueDt = new Date(value);
      const todayDt = new Date(this.todaysDate);
      const diffMs = todayDt - valueDt;
      if (isNotBeforeTwoPrior && diffMs > 0) {
        const errMsg = `Please remember to export data for the GL for ${value}
        as this change will affect GL balances for ${value}.`;
        this.flashInfo(errMsg);
      }
    },
    emitEditBatchPaymntItem() {
      this.$emit('emitEditBatchPaymntItem', this.editedItem.transactionNumberObject);
    },
    whomUpdateSearchInput(val) {
      this.whomLastSearched = val;
    },
    whomUpdateSearchInputByNumber(number) {
      this.whomLastSearched = this.whoms[number];
    },
    async whomShortcutHandler(e) {
      if (e.key === 'Tab') {
        const { whomStr } = this.editedItem;
        const { whomLastSearched } = this;
        const fields = {
          _id: '',
          description: '',
          fiscalYear: '',
        };
        const matchWhoms = this.whoms.filter((w) => w === whomStr);
        const matchWhomLastSearched = this.whoms.filter(
          (w) => w === whomLastSearched,
        );
        if (matchWhoms.length > 0 || whomLastSearched) {
          const matchWhom = matchWhoms[0] ? matchWhoms[0] : '';
          if (
            (matchWhom || '').toLowerCase()
              !== (whomLastSearched || '').toLowerCase()
            && matchWhomLastSearched.length === 0
          ) {
            this.flashInfo('Creating a new Whom entry.');
            // create a new record to match the description typed
            const item = {
              description: whomLastSearched,
              fiscalYear: this.editedItem.fiscalYear,
            };
            await this.upsrtCmnWhom({
              item,
              fields,
              baseCrudKey: this.whomListCrudKey,
            });
            await this.loadCmnWhom({
              criteria: {
                fiscalYear: this.editedItem.fiscalYear,
              },
              fields,
              baseCrudKey: this.whomListCrudKey,
            });
          }
          this.editedItem.whomStr = whomLastSearched;
        }
        this.handlingTabOrder(e);
      }
    },
    handleSourceUpdate() {
      this.$emit('source-updated', this.sources);
    },
    totalRemainingPaymentAmount(value) {
      this.totalRemainingPayAmt = amountToNumber(value);
      return value;
    },
    totalRemainingReconAmount(value) {
      this.totalReconAmount = amountToNumber(value);
      return value;
    },
    roundAmount() {
      this.editedItem.amount = amountFormat(amountToNumber(this.editedItem.amount));
    },
    amountToNum() {
      this.editedItem.amount = amountToNumber(this.editedItem.amount);
    },
    showTaxSummaryReceiptBtn() {
      this.$emit('showOnClickApportionLikeTax', this.editedItem.isApportionLikeTax);
    },
    showSpecialApportionmentBtn() {
      this.$emit('showOnClickSpecialApportionment', this.editedItem.isSpecialApportionment);
    },
    prefillSpecialAxGlDate() {
      if (this.editedItem.isSpecialApportionment && !this.editedItem.specialAxGlDate) {
        this.editedItem.specialAxGlDate = this.editedItem.businessDate;
      }
    },
    loadLists() {
      if (this.fiscalYearLength === 4) {
        this.loadFundList();
        this.loadSourceList();
        this.loadUnitCodeList();
        this.loadCmnWhomList();
        this.loadTaxUnitList();
      }
    },
    async loadTaxUnitList() {
      await this.loadTaxUnit({
        criteria: {
          fiscalYear: this.editedItem.fiscalYear,
        },
        baseCrudKey: taxUnitCrudKey,
      });
      this.taxUnits = this.items(taxUnitCrudKey) || [];
    },
    async loadFundList() {
      const fundObjs = await this.loadFunds({
        criteria: {
          fiscalYear: this.editedItem.fiscalYear,
          sortBy: [
            {
              column: 'fund',
              direction: 'asc',
            },
          ],
        },
      });
      const updatedFundObj = fundObjs.filter((f) => isBudgetedFundOrCashFund(f.type))
        .map((f) => ({
          ...f,
          fundDesc: `${f.fund} ${f.description || ''}`,
        }));
      this.funds = [{ _id: null, fund: '', fundDesc: '' }, ...updatedFundObj];
    },
    async loadSourceList() {
      const sourceObjs = await this.loadCmnSource({
        criteria: {
          fiscalYear: this.editedItem.fiscalYear,
          isSkipMiscellaneousTransaction: false,
          sortBy: [
            {
              column: 'sourceSubSourceNumber',
              direction: 'asc',
            },
          ],
        },
      });
      const updatedSourceObj = sourceObjs.map((s) => {
        const firstPartDesc = `${s.sourceSubSourceNumber} ${s.sourceDescription || ''}`;
        const secondPartDesc = s.subSourceDescription;
        return {
          ...s,
          sourceDesc: secondPartDesc == null || '' ? `${s.sourceSubSourceNumber} ${s.sourceDescription}` : `${firstPartDesc} - ${secondPartDesc}`,
        };
      });
      this.sources = [{ _id: null, sourceSubSourceNumber: '', sourceDesc: '' }, ...updatedSourceObj];
      this.handleSourceUpdate();
    },
    async loadUnitCodeList() {
      const unitCodeObjs = await this.loadMiscUnitCode({
        criteria: {
          fiscalYear: this.editedItem.fiscalYear,
          sortBy: [
            {
              column: 'unitCode',
              direction: 'asc',
            },
          ],
        },
      });
      const updatedUnitObj = unitCodeObjs.map((u) => ({
        ...u,
        unitDesc: `${u.unitCodeNumber} ${u.description || ''}`,
      }));
      this.unitCodes = [{ _id: null, unitCode: '', unitDesc: '' }, ...updatedUnitObj];
      // this.unitCodes = updatedUnitObj;
    },
    async loadCmnWhomList() {
      await this.loadCmnWhom({
        criteria: {
          fiscalYear: this.editedItem.fiscalYear,
        },
        baseCrudKey: 'miscWhom',
      });
    },
    determineReceiptNo() {
      if (this.isNewItem) {
        if (this.fiscalYearLength !== 4) {
          this.setReceiptPolling(undefined);
        } else {
          const miscTransPolling = setInterval(
            this.getRecNo,
            1200,
          );
          this.setReceiptPolling(miscTransPolling);
        }
      }
    },
    getRecNo() {
      if (!this.isNewItem) {
        this.setReceiptPolling(undefined);
        return;
      }
      const { fiscalYear } = this.editedItem;
      if (!(checkStringEmptiness(fiscalYear))) {
        this.determineNextReceiptNo(
          {
            fiscalYear,
          },
        );
      }
    },
    determineNextReceiptNo({ fiscalYear }) {
      const loadReceiptNoPromise = this.loadLastReceiptNo(
        { fiscalYear },
      );
      loadReceiptNoPromise.then(() => {
        if (!this.isNewItem) {
          // the record was saved while this lookup was in flight; reassigning
          // here renumbers the already-saved receipt (TKT-000805)
          this.setReceiptPolling(undefined);
          return;
        }
        this.editedItem.receiptNumber = this.nextReceiptNumber;
        this.$nextTick(() => {
          this.setReceiptPulse(true);
        });
      });
    },
    setCalculatePercentage(value) {
      this.forceReloadDetails = false;
      this.editedItem.isCalculatePercentage = value;
      this.$nextTick(() => {
        this.forceReloadDetails = true;
      });
    },
    isCorrectionChecked() {
      if (!this.editedItem.isCorrection) {
        return;
      }
      // A correction carries no payment details: the money was collected on an earlier
      // day, and moving it back out is done with manual GL entries.
      if (hasEnteredPaymentDetails(this.editedItem.paymentDetails)
        && !window.confirm(correctionClearsPaymentDetailsPrompt)) {
        this.editedItem.isCorrection = false;
        return;
      }
      this.editedItem.paymentDetails = [];
    },
    isVoidChecked() {
      if (this.editedItem.isVoid) {
        this.editedItem.amount = 0.00;
        this.editedItem.details = (this.editedItem.details || []).map((item) => {
          const updatedDetail = { ...item };
          updatedDetail.amount = 0.00;
          return updatedDetail;
        });
        this.editedItem.paymentDetails = (this.editedItem.paymentDetails || []).map((item) => {
          const updatedVoidedItem = { ...item };
          updatedVoidedItem.amount = 0.00;
          updatedVoidedItem.paymentType = 'OTHER';
          return updatedVoidedItem;
        });
        this.editedItem.whomStr = '*VOID*';
        this.$emit('voidTransactionOnSave', true);
      }
    },
    loadFiles() {
      this.loadAttachedFiles({
        bucketName: this.attachmentConstants.bucketName,
        program: this.attachmentConstants.program,
        parentObjectType: this.attachmentConstants.parentObjectType,
        parentObjectId: this.editedItem._id,
      });
    },
    miscForteResponse(res) {
      this.editedItem.description += res;
    },
    determineTransactionNo() {
      if (this.isNewItem) {
        if (this.fiscalYearLength !== 4) {
          this.setTransNoPolling(undefined);
        } else {
          const transNoPolling = setInterval(
            this.getTransNo,
            1200,
          );
          this.setTransNoPolling(transNoPolling);
        }
      }
    },
    getTransNo() {
      if (!this.isNewItem) {
        this.setTransNoPolling(undefined);
        return;
      }
      const { fiscalYear } = this.editedItem;
      if (!(checkStringEmptiness(fiscalYear))) {
        this.determineNextTransNo(
          {
            fiscalYear,
          },
        );
      }
    },
    determineNextTransNo({ fiscalYear }) {
      const loadTransNoPromise = this.loadLastTransactionNo(
        { fiscalYear },
      );
      loadTransNoPromise.then(() => {
        if (!this.isNewItem) {
          this.setTransNoPolling(undefined);
          return;
        }
        this.editedItem.transactionNumber = this.nextTransNumber;
        this.$nextTick(() => {
          this.setTransNoPulse(true);
        });
      });
    },
    handlingTabOrder(e) {
      if (this.editedItem && this.editedItem.whomStr) {
        e.preventDefault();
        document.getElementById('miscEditDialogBankNameSelect').focus();
      }
    },
    businessDateValidation(value) {
      const fy = this.editedItem.fiscalYear;
      const fyStart = new Date(`${fy - 1}-07-01`);
      const fyEnd = new Date(`${fy}-07-07`);
      const businessDate = new Date(toIsoDate(value));
      return (
        (businessDate >= fyStart && businessDate <= fyEnd)
        || 'Business Date must fall within the fiscal year'
      );
    },
    specialAxGlDateValidation(value) {
      const fy = this.editedItem.fiscalYear;
      const fyStart = new Date(`${fy - 1}-07-01`);
      const fyEnd = new Date(`${fy}-07-07`);
      const glDate = new Date(toIsoDate(value));
      return (
        (glDate >= fyStart && glDate <= fyEnd)
        || 'GL Date must fall within the fiscal year'
      );
    },
  },
};
</script>
